var n, a = [], u = function() {
  return a.splice(0).forEach(function(r) {
    return r();
  });
}, o = function(r) {
  if (!n) {
    var t = 0, e = document.createTextNode(""), c = { characterData: !0 };
    new MutationObserver(function() {
      return u();
    }).observe(e, c), n = function() {
      e.textContent = "".concat(t ? t-- : t++);
    };
  }
  a.push(r), n();
};
export {
  o as queueMicroTask
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/utils/queueMicroTask.js
// module id = 1315
// module chunks = 41